import React, { useEffect, memo } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import PureCounter from '@srexi/purecounterjs';

function About() {
    useEffect(() => {
        new PureCounter();
        AOS.init({
            duration: 1000,
            once: true,
        });
    }, []);

    return (
        <section id="about" className="about section" data-aos="fade-up" data-aos-delay="100">
            <div className="container section-title">
                <h2>About</h2>
                <div>
                    <span className="description-title">About Us</span>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-6 col-sm-6 content">
                        <p>
                            <strong>GANPATI COMPUTERS</strong> is your trusted partner for all computer and printer-related needs. Located at <strong>Nau Gaja Peer, College Road, Ropar</strong>, we offer comprehensive services including hardware & software solutions, AMC networking, repairing, and printer repair. Our expert technicians are dedicated to providing reliable and affordable services to both individual and business clients.
                        </p>
                        <p>
                            We specialize in SSD upgrades, hard disk recovery, custom PC building, and supplying genuine spare parts. Whether you need a high-performance gaming rig, a workstation for your office, or quick repairs for your laptop or printer, we have the expertise to deliver. Our goal is to keep your technology running smoothly with fast turnaround and quality workmanship.
                        </p>
                        <p>
                            Contact us today at <strong>M. 99888-93537</strong> or visit our shop near Nau Gaja Peer, College Road, Ropar. We serve customers from all over Ropar and nearby areas. Experience professional computer care with GANPATI COMPUTERS – where quality meets affordability.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default memo(About);